// Function for end of transition for each D3 plot
export const endall = (transition, callback) => {
  if (typeof callback !== 'function')
    throw new Error('Wrong callback in endall');
  if (transition.size() === 0) {
    callback();
  }
  let n = 0;
  transition
    // biome-ignore lint/complexity/useArrowFunction: migrated from develop
    .each(function () {
      ++n;
    })
    .on('end', function () {
      // biome-ignore lint/complexity/noArguments: migrated from develop
      if (!--n) callback.apply(this, arguments);
    });
};
